import { ToastrService } from 'ngx-toastr';
import { Component, Input, OnChanges, OnInit, SimpleChanges, TemplateRef } from '@angular/core';
import { GeneralService, Property, ImageService } from '@clooper/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { faTimes, faCircleNotch, faCheck, faInfoCircle, faPencil } from '@fortawesome/pro-light-svg-icons';

@Component({
  selector: 'app-add-room-photos-modal',
  templateUrl: './add-room-photos-modal.component.html',
  styleUrls: ['./add-room-photos-modal.component.scss']
})
export class AddRoomPhotosModalComponent implements OnInit, OnChanges {
  @Input() propertyDetails: Property;
  @Input() roomId: string
  defaultImg = "/assets/resource/uploading-img.png";
  modalRef?: BsModalRef;
  imgLoading = { caption: false }
  selectedImg: any;
  icons = {
    times: faTimes,
    spinner: faCircleNotch,
    check: faCheck,
    info: faInfoCircle,
    pencil: faPencil
  }
  images: any[] = [];
  uploadingState = false;
  deleteImgModalData = {
    confirmQuestion: 'Are you sure you want to delete this image?',
    confirm: { loading: false, text: 'Delete' },
    itemName: 'Image 1'
  }
  constructor(
    private modalService: BsModalService,
    private imageService: ImageService,
    private gs: GeneralService,
    private toastr: ToastrService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.roomId.currentValue !== changes.roomId.previousValue) {
      this.imageService.setParent(this.propertyDetails.id, this.roomId);
    }
  }

  ngOnInit(): void {
    if (!this.roomId) return;
    this.imageService.setParent(this.propertyDetails.id, this.roomId);
    this.fetchRoomImages()
  }

  fetchRoomImages() {
    this.imageService.fetch().subscribe((images: any[]) => {
      this.images = images;
    })
  }

  fileUploadUpdate(file: any) {
    this.uploadingState = true
    if (file.status === 'complete') {
      file.is_default = this.images.length === 1;
      const index = this.images.findIndex(img => img.hash === file.hash);
      const imgFile = this.images[index];
      this.images[index] = { ...imgFile, ...file };
      this.saveImage(file);
    } else {
      this.images?.unshift(file);
    }
  }

  saveImage(file: any) {
    const { description, is_default, url } = file;
    this.imageService.create({ is_default, url, description } as any).subscribe(res => {
      this.fetchRoomImages();
    }).add(() => this.uploadingState = false)
  }

  onDeleteImg(template: TemplateRef<any>, img: any) {
    this.selectedImg = img;
    this.deleteImgModalData.itemName = img.description;
    this.modalRef = this.modalService.show(template, { class: 'modal-rounded' })
  }

  deleteImage(event: any) {
    if (event.type !== 'confirm') return;
    this.deleteImgModalData.confirm.loading = true;
    this.imageService.delete(this.selectedImg._id).subscribe((res: any) => {
      this.fetchRoomImages()
      this.toastr.success('Room Image Deleted');
      this.modalRef?.hide()
    }, err => {
      this.toastr.error(this.gs.getErrMsg(err))
    }).add(() => this.deleteImgModalData.confirm.loading = false)
  }

  onAddCaption(template: any, img: any) {
    this.selectedImg = img;
    this.modalRef = this.modalService.show(template, { class: 'modal-rounded' })
  }

  saveImgCaption(event: any) {
    if (event.type !== 'save') return;
    this.imgLoading.caption = true;
    const { description } = event.data;
    const payload: any = { id: this.selectedImg._id, description }
    this.imageService.update(payload).subscribe(() => {
      this.fetchRoomImages();
      this.modalRef?.hide()
    }, err => {
      this.toastr.error(this.gs.getErrMsg(err))
    }).add(() => this.imgLoading.caption = false)
  }

  useAsThumbnail(img: any) {
    const is_default = true;
    const payload: any = { id: img._id, is_default }
    this.imageService.update(payload).subscribe(() => {
      this.fetchRoomImages();
      this.toastr.success('Photo used as thumbnail')
    }, err => {
      this.toastr.error(this.gs.getErrMsg(err))
    })
  }
}
